import $ from 'jquery'
import jQuery from 'jquery'

(window as any).$ = $;
(window as any).jQuery = jQuery;